import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules'; // 👈 Autoplay added here

import 'swiper/css';
import 'swiper/css/pagination';
import './Ourteam.css';

function Ourteam() {
  const teamMembers = [
    {
      name: 'Reena Pareek',
      role: 'Admin',
      img: '/img/aunt1.jpeg',
    },
    {
      name: 'Kavita Choudhary',
      role: 'Member Of Core Team',
      img: '/img/aunt2.jpeg',
    },
    {
      name: 'Archana Choudhary',
      role: 'Member Of Core Team',
      img: '/img/aunt3.jpeg',
    },
    {
      name: 'Uk Singh ',
      role: 'Founder Of Gateway Landmark Group',
      img: '/img/uncle2.jpeg',
    },
    {
      name: 'Rajesh Kumar',
      role: 'Member Of Core Team',
      img: '/img/uncle.jpeg',
    },
    {
      name: 'Mr. Sunil Nehra',
      role: 'Member Of Core Team',
      img: '/img/uncle1.jpeg',
    },
    {
      name: 'Mr Gaurav Sharma Advocate',
      role: 'Legal Department',
      img: '/img/uncle45 (2).jpeg',
    },
    {
      name: 'Mr Bhagwati Parsad Rajoria ',
      role: 'Member Of Core Team',
      img: '/img/uncle44 (1).jpeg',
    },
    {
      name: 'Siddhartha Choudhary',
      role: 'Member Of Core Team',
      img: '/img/bhai.jpeg',
    },
    {
      name: 'Mr Sanjeev Mittal',
      role: 'Member Of Core Team',
      img: '/img/bhai2.jpeg',
    },
    {
      name: 'Sh. Chandra Shekhar Khandelwal ',
      role: 'Member Of Core Team',
      img: '/img/uncle88.jpeg',
    },
    {
      name: 'Sh. K.K. Agrawal ',
      role: 'Member Of Core Team',
      img: '/img/uncle77.jpeg',
    },
  ];

  return (
    <div className="teamh">
      <div className="container">
        <div className="section-title">
          <h1>Team</h1>
        </div>

        <Swiper
          slidesPerView={1}
          spaceBetween={30}
          pagination={{ clickable: true }}
          autoplay={{
            delay: 2500, // 👈 time between slides (in milliseconds)
            disableOnInteraction: false,
          }}
          breakpoints={{
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
          }}
          modules={[Pagination, Autoplay]} // 👈 Autoplay module included
          className="mySwiper"
        >
          {teamMembers.map((member, index) => (
            <SwiperSlide key={index}>
              <div className="team-9">
                <div className="team-img">
                  <img src={member.img} alt={member.name} />
                </div>
                <div className="team-content">
                  <h2>{member.name}</h2>
                  <h3>{member.role}</h3>
                </div>
                <div className="team-overlay">
                  <p>Some text goes here that describes about team member</p>
                  <div className="team-social">
                    <a className="social-tw" href="#"><i className="fab fa-twitter"></i></a>
                    <a className="social-fb" href="#"><i className="fab fa-facebook-f"></i></a>
                    <a className="social-li" href="#"><i className="fab fa-linkedin-in"></i></a>
                    <a className="social-in" href="#"><i className="fab fa-instagram"></i></a>
                    <a className="social-yt" href="#"><i className="fab fa-youtube"></i></a>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}

export default Ourteam;
